import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import SwipeableViews from "react-swipeable-views";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import {
  Button,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@material-ui/core";
import { gpColors } from "../../constants/colors";
import ProductDetailModal from "./ProductDetailModal";
import { useNavigate } from "react-router-dom";
import { routes } from "../../constants/routes";
import DataTable from "react-data-table-component";
import api from "../Interceptors/axiosInstance";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: "100%",
    marginTop: "5%",
  },
  deleteButton: {
    textTransform: "none",
    backgroundColor: gpColors.logoBrown,
    marginRight: "10px",
    color: "#fff",
    "&.MuiButtonBase-root": {
      "&:hover": { backgroundColor: gpColors.logoBrown },
    },
  },
  editButton: {
    textTransform: "none",
    backgroundColor: gpColors.editButton,
    marginLeft: "10px",
    color: "#fff",
    "&.MuiButtonBase-root": {
      "&:hover": { backgroundColor: gpColors.editButton },
    },
  },
  tableRow: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
  tableHead: {
    backgroundColor: "#4a4a4a",
    color: "#fff",
  },
  loaderContainer: {
    textAlign: "center",
    color: "#BE0A00",
    alignItems: "center",
    backgroundColor: "",
    display: "flex",
    justifyContent: "center",
    height: "30vh",
  },
  noDataContainer: {
    textAlign: "center",
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    height: "30vh",
  },
}));

function ProductDetails(props) {
  const navigate = useNavigate();
  const [oilFilterLoader, setOilFilterLoader] = useState(false);
  const [airFilterLoader, setAirFilterLoader] = useState(false);
  const [fuelFilterLoader, setFuelFilterLoader] = useState(false);
  const [oilFilterData, setOilFilterData] = useState([]);
  const [airFilterData, setAirFilterData] = useState([]);
  const [fuelFilterData, setFuelFilterData] = useState([]);
  const [deleteData, setDeleteData] = useState({});
  const [confirmModal, setConfirmModal] = useState(false);
  const [successAlert, setSuccessAlert] = useState(false);
  const [oilSearchPart, setOilSearchPart] = useState("");
  const [airSearchPart, setAirSearchPart] = useState("");
  const [fuelSearchPart, setFuelSearchPart] = useState("");
  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setOilSearchPart("");
    setAirSearchPart("");
    setFuelSearchPart("");
  };

  const handleChangeIndex = (index) => {
    setValue(index);
    setOilSearchPart("");
    setAirSearchPart("");
    setFuelSearchPart("");
  };

  const oilColumns = [
    {
      name: "GPA#",
      selector: (row) => row.part_no,
      sortable: true,
      center: true,
    },
    {
      name: "Actions",
      center: true,
      cell: (row) => (
        <>
          <Button
            className={classes.deleteButton}
            onClick={() =>
              openConfirmModal({
                part_no: row.part_no,
                image_name: row.image_name,
              })
            }
          >
            Delete
          </Button>
          <Button
            className={classes.editButton}
            onClick={() => handleEditNavigation(row.part_no)}
          >
            Edit
          </Button>
        </>
      ),
    },
  ];

  const airColumns = [
    {
      name: "GPA#",
      selector: (row) => row.part_no,
      sortable: true,
      center: true,
    },
    {
      name: "Actions",
      center: true,
      cell: (row) => (
        <>
          <Button
            className={classes.deleteButton}
            onClick={() =>
              openConfirmModal({
                part_no: row.part_no,
                image_name: row.image_name,
              })
            }
          >
            Delete
          </Button>
          <Button
            className={classes.editButton}
            onClick={() => handleEditNavigation(row.part_no)}
          >
            Edit
          </Button>
        </>
      ),
    },
  ];

  const fuelColumns = [
    {
      name: "GPA#",
      selector: (row) => row.part_no,
      sortable: true,
      center: true,
    },
    {
      name: "Actions",
      center: true,
      cell: (row) => (
        <>
          <Button
            className={classes.deleteButton}
            onClick={() =>
              openConfirmModal({
                part_no: row.part_no,
                image_name: row.image_name,
              })
            }
          >
            Delete
          </Button>
          <Button
            className={classes.editButton}
            onClick={() => handleEditNavigation(row.part_no)}
          >
            Edit
          </Button>
        </>
      ),
    },
  ];
  const filteredOilData = Array.isArray(oilFilterData)
  ? oilFilterData.filter((item) =>
      item.part_no?.toLowerCase().includes(oilSearchPart.toLowerCase())
    )
  : [];

  const filteredAirData = Array.isArray(airFilterData)
  ? airFilterData.filter((item) =>
      item.part_no?.toLowerCase().includes(airSearchPart.toLowerCase())
  ):[];

  const filteredFuelData = Array.isArray(fuelFilterData)
  ? fuelFilterData.filter((item) =>
    item.part_no?.toLowerCase().includes(fuelSearchPart.toLowerCase())
  ):[];
  
  useEffect(() => {
    // get data from API
    getOilFilterDetails();
    getAirFilterDetails();
    getFuelFilterDetails();
  }, []);
  //   when new product added then again call API
  useEffect(() => {
    // console.log(props.updateData);
    if (props.updateData === true) {
      getOilFilterDetails();
      getAirFilterDetails();
      getFuelFilterDetails();
    }
  }, [props.updateData]);
  //   console.log("---------------props.updateData", props.updateData);
  const getOilFilterDetails = async () => {
    setOilFilterLoader(true);
    try {
      // const resp = await fetch(
      //   `${process.env.REACT_APP_API_ENDPOINT}/getProducts/${1}`,
      //   {
      //     method: "GET",
      //     headers: {
      //       // // "ngrok-skip-browser-warning": "true",
      //     },
      //   }
      // );
      const resp = await api.get(`/getProducts/1`);
      const data = await resp.data;
      //   console.log(data);
      setOilFilterData(data);
      setOilFilterLoader(false);
    } catch (e) {
      console.log(e.message);
      setOilFilterLoader(false);
    }
    props.setUpdateData(false);
  };

  const getAirFilterDetails = async () => {
    setAirFilterLoader(true);
    try {
      // const resp = await fetch(
      //   `${process.env.REACT_APP_API_ENDPOINT}/getProducts/${2}`,
      //   {
      //     method: "GET",
      //     headers: {
      //       // // "ngrok-skip-browser-warning": "true",
      //     },
      //   }
      // );
      const resp = await api.get(`/getProducts/2`);
      const data = await resp.data;
      //   console.log(data);
      setAirFilterData(data);
      setAirFilterLoader(false);
    } catch (e) {
      console.log(e);
      setAirFilterLoader(false);
    }
    props.setUpdateData(false);
  };

  const getFuelFilterDetails = async () => {
    setFuelFilterLoader(true);
    try {
      // const resp = await fetch(
      //   `${process.env.REACT_APP_API_ENDPOINT}/getProducts/${3}`,
      //   {
      //     method: "GET",
      //     headers: {
      //       // // "ngrok-skip-browser-warning": "true",
      //     },
      //   }
      // );
      const resp = await api.get(`/getProducts/3`);
      const data = await resp.data;
      //   console.log(data);
      setFuelFilterData(data);
      setFuelFilterLoader(false);
    } catch (e) {
      console.log(e);
      setFuelFilterLoader(false);
    }
    props.setUpdateData(false);
  };

  //   open confirmation modal
  const openConfirmModal = (data) => {
    setDeleteData(data);
    setConfirmModal(true);
  };
  //   console.log(confirmModal);

  //   close confirmation modal and perform operation depend on choice
  const closeConfirmModal = (choice) => {
    if (choice === "DELETE") {
      deleteProduct();
    }
    setConfirmModal(false);
  };

  //   close successfully product deleted alert box
  const handleAlertClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSuccessAlert(false);
  };

  const deleteProduct = async () => {
    try {
      // const resp = await fetch(
      //   `${process.env.REACT_APP_API_ENDPOINT}/deleteProducts/${deleteData.part_no}/${deleteData.image_name}`,
      //   {
      //     method: "DELETE",
      //     headers: {
      //       Authorization: `Token ${props.userData.loginInfo.data.jwt}`,
      //       // // "ngrok-skip-browser-warning": "true",
      //     },
      //   }
      // );
      const resp = await api.delete(`/deleteProducts/${deleteData.part_no}/${deleteData.image_name}`);
      const data = await resp.data;
      if (data.result === "Deleted") {
        // console.log("Deleted");
        if (value === 0) {
          getOilFilterDetails();
        } else if (value === 1) {
          getAirFilterDetails();
        } else if (value === 2) {
          getFuelFilterDetails();
        }
        setSuccessAlert(true);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleEditNavigation = (part_no) => {
    console.log('handle edit navigation: ', part_no)
    navigate(routes.EDIT_PRODUCTS);
    console.log(part_no);
    localStorage.setItem("part_no", JSON.stringify({ part_no: part_no }));
  };
  return (
    <div className={classes.root}>
      <AppBar position="static" color="default">
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          aria-label="full width tabs example"
        >
          <Tab label="OIL FILTERS" {...a11yProps(0)} />
          <Tab label="AIR FILTERS" {...a11yProps(1)} />
          <Tab label="FUEL FILTERS" {...a11yProps(2)} />
        </Tabs>
      </AppBar>
      <SwipeableViews
        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
        index={value}
        onChangeIndex={handleChangeIndex}
      >
        {/* OIL FILTER DATA */}
        <TabPanel value={value} index={0} dir={theme.direction}>
          {oilFilterLoader === true && (
            <Box className={classes.loaderContainer}>
              <CircularProgress color="inherit" />
            </Box>
          )}
          <>
            <Box display="flex" justifyContent="end" margin={2}>
              <TextField
                placeholder="Search..."
                size="small"
                variant="outlined"
                onChange={(e) => setOilSearchPart(e.target.value)}
              />
            </Box>
            {/* Datatable */}
            <Box sx={{ borderRadius: 2, overflow: "hidden" }}>
              <DataTable
                columns={oilColumns}
                data={filteredOilData}
                progressPending={oilFilterLoader}
                progressComponent={
                  <CircularProgress color="inherit" size={25} />
                }
                noDataComponent={
                  <div style={{ color: "#F22F46", fontWeight: 600, marginTop:'20px' }}>
                    No Data Found
                  </div>
                }
                pagination
                paginationRowsPerPageOptions={[5, 10, 15, 20, 50, 100]}
                defaultSortFieldId={1}
                highlightOnHover
                striped
                responsive
                persistTableHead
                customStyles={{
                  headCells: {
                    style: {
                      backgroundColor: gpColors.logoGray,
                      color: "#fff",
                      fontWeight: "bold",
                      justifyContent: "center",
                    },
                  },
                  rows: {
                    style: {
                      fontSize: "0.875rem",
                    },
                  },
                }}
              />
            </Box>
          </>
        </TabPanel>
        {/* AIR FILTER DATA */}
        <TabPanel value={value} index={1} dir={theme.direction}>
          {airFilterLoader === true && (
            <Box className={classes.loaderContainer}>
              <CircularProgress color="inherit" />
            </Box>
          )}
          <>
            <Box display="flex" justifyContent="end" margin={2}>
              <TextField
                placeholder="Search..."
                size="small"
                variant="outlined"
                onChange={(e) => setAirSearchPart(e.target.value)}
              />
            </Box>
            {/* Datatable */}
            <Box sx={{ borderRadius: 2, overflow: "hidden" }}>
              <DataTable
                columns={airColumns}
                data={filteredAirData}
                progressPending={airFilterLoader}
                progressComponent={
                  <CircularProgress color="inherit" size={25} />
                }
                noDataComponent={
                  <div style={{ color: "#F22F46", fontWeight: 600, marginTop:'20px' }}>
                    No Data Found
                  </div>
                }
                pagination
                paginationRowsPerPageOptions={[5, 10, 15, 20, 50, 100]}
                defaultSortFieldId={1}
                highlightOnHover
                striped
                responsive
                persistTableHead
                customStyles={{
                  headCells: {
                    style: {
                      backgroundColor: gpColors.logoGray,
                      color: "#fff",
                      fontWeight: "bold",
                      justifyContent: "center",
                    },
                  },
                  rows: {
                    style: {
                      fontSize: "0.875rem",
                    },
                  },
                }}
              />
            </Box>
          </>
        </TabPanel>

        {/* FUEL FILTER DATA */}
        <TabPanel value={value} index={2} dir={theme.direction}>
          {fuelFilterLoader === true && (
            <Box className={classes.loaderContainer}>
              <CircularProgress color="inherit" />
            </Box>
          )}

          <>
            <Box display="flex" justifyContent="end" margin={2}>
              <TextField
                placeholder="Search..."
                size="small"
                variant="outlined"
                onChange={(e) => setFuelSearchPart(e.target.value)}
              />
            </Box>
            {/* Datatable */}
            <Box sx={{ borderRadius: 2, overflow: "hidden" }}>
              <DataTable
                columns={fuelColumns}
                data={filteredFuelData}
                progressPending={fuelFilterLoader}
                progressComponent={
                  <CircularProgress color="inherit" size={25} />
                }
                noDataComponent={
                  <div style={{ color: "#F22F46", fontWeight: 600, marginTop:'20px' }}>
                    No Data Found
                  </div>
                }
                pagination
                paginationRowsPerPageOptions={[5, 10, 15, 20, 50, 100]}
                defaultSortFieldId={1}
                highlightOnHover
                striped
                responsive
                persistTableHead
                customStyles={{
                  headCells: {
                    style: {
                      backgroundColor: gpColors.logoGray,
                      color: "#fff",
                      fontWeight: "bold",
                      justifyContent: "center",
                    },
                  },
                  rows: {
                    style: {
                      fontSize: "0.875rem",
                    },
                  },
                }}
              />
            </Box>
          </>
        </TabPanel>
      </SwipeableViews>

      <ProductDetailModal
        confirmModal={confirmModal}
        closeConfirmModal={closeConfirmModal}
        successAlert={successAlert}
        handleAlertClose={handleAlertClose}
      />
    </div>
  );
}

export default ProductDetails;
